module.exports = __webpack_public_path__ + "static/img/product_banner_28_zh.c384663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_28_zh.png
// module id = 84k6
// module chunks = 34